export default __webpack_public_path__ + "static/media/placement-success.c0040468.gif";